import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  galleryList: AngularFireList<any>;

  constructor(private firebase: AngularFireDatabase) { }

  getGalleryList() {
    this.galleryList = this.firebase.list('imageDetails');
    return this.galleryList;
  }
}
